import config from '../config'

import createAuthService from '../../../commons/src/services/auth'
import {forceReload} from '../../../commons/src/services/reload'

export default createAuthService(config.amplify, forceReload)
